<template>
<div id="companyProfile">
    <h2 class="h2top">COMPANY PROFILE</h2>
    <h2 class="h2bottom">公司介绍</h2>
    <div class="lineClass"></div>
    <div style="text-align:center">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">企业介绍</el-menu-item>
			<el-menu-item index="2">发展历程</el-menu-item>
			<el-menu-item index="3">创始团队</el-menu-item>
		</el-menu>
    <div v-show="key == 1" class="keyOne">
				<div class="keyOneL">
					<div><h2>中卡运行</h2><div class="line"></div><span>物流行业领先的车货满</span></div>
					<div style="color:#419EFF;font-size:1.4vw;">单排期、无缝对接物流服务平台</div>
					<p style="width:95%;font-size:0.8vw;color:#343434;margin-top:30px;">“中运卡行”是运用雄厚的技术研发实力和对物流运作模式的深刻理解而研发的
用于整合市场上车货资源的网络货运交易平台。平台主要为车主和货主之间搭
建诚信便利的交易通道、促使货运交易达成、圆满完成运输任务。平台致力于
为交易双方实现对订单、运输过程、结算等全程的可视化规范化管理，提升综
合服务能力，推进物流供给侧结构性改革，相应国家绿色节能减排的号召，促
进物流各方的降本增效。<br/>全自营车队：货运司机7区32项标准职业化培训，服务全程上险，专业又靠谱；
首推群体：危险品、冷链物流服务需求的客户；
愿景：全资质全产业链服务提供商。</p>
			</div>
			<img class="keyOneR" v-lazy="'../../static/img/keyOne.png'">
    </div>
    <div v-show="key == 2" style="margin-top:50px;margin-bottom:50px">
			<el-row>
				<el-col :span="4" v-for="(item, index) in data" :key="index" :offset="index > 0 ? 1 : 0">
					<el-card :body-style="{ padding: '0px' }">
						<div style="position:relative" @mouseenter="enter(item.title)" @mouseleave="leave">
							<img v-lazy="item.src" class="image">
							<transition name="fullscreen">
							<div v-if="isshow == item.title" class="imgtxt" style="font-size:50%">{{item.txt}}</div>
							</transition>
						</div>
					<div style="padding: 14px;text-align:left;position:relative;z-index:9999;background-color:#fff">
						<span style="font-size:0.7vw;">{{item.title}}</span>
						<div class="bottom clearfix">
							<time class="time">{{ item.time }}</time>
						</div>
						<img style="width:1.5vw;height:1.5vw;position:absolute;top:14px;right:14px;" v-lazy="item.icon" alt="">
					</div>
					</el-card>
				</el-col>
			</el-row>
    </div>
    <div v-show="key == 3" class="bg">
      <p style="color:white;font-size:1vw;margin-bottom:3vw">中运卡行拥有一支经验丰富、眼光独到，专业创新的软件研发团队，凭借多年的实践经验；一直坚持高标准的服务。</p>
      <div style="display:flex;">
            <div style="width:13vw;">
             <div class="itemClass" :style="{height: setHeight}">
                <p class="title">吴松松</p>
                <p class="content">资深架构师，多年互联网从业经验。曾主导大型军工项目、互联网项目、物联网项目、大数据项目等研发。对数据的安全性、保密性、完整性等有深刻理解。熟悉各大主流的大数据、数据分析、分布式、微服务等架构。灵活应对数据高并发，互联网高峰</p>
              </div>
               <img v-lazy="'../../static/img/wusongsong.png'" alt="">
            </div>
            <div style="width:13vw;">
              <img v-lazy="'../../static/img/laoban.png'" alt="">
              <div class="itemClass" style="background: rgba(65, 158, 255, 0.7);" :style="{height: setHeight}">
                <p class="title">王庆全</p>
                <p class="content">企业CEO，项目早期发起人。25年以上物流企业领军经验。管理多家以危险品物流为主的国际货物运输企业，公司拥有海关监管、冷链管理一体化的物流设备和设施。目前公司已经通过ISO9001-2008国际质量管理体系认证和RSQAS体系认证，公司自主拥有各种车型的长短货车400余辆</p>
              </div>
            </div>
            <div style="width:13vw;">
              <div ref="getheight" class="itemClass">
                <p class="title">余泳</p>
                <p class="content">16年互联网B2B、B2C、C2C、O2O类影院、餐饮、快消品和医疗医药行业项目多渠道线上线下全网营销从0到上市经验。熟悉腾迅、阿里、头条、百度系各大推广渠道，实操信息流、微信MP、搜索、电商营销推广工具,操盘过百度搜索、头条信息流、微信公众号广告主KA大客户部门巨量框架任务</p>
              </div>
              <img v-lazy="'../../static/img/yuyong.png'"  alt="">
            </div>
      </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
data () {
	return {
		activeIndex: '1',
		key: 1, // 显示哪页
		data: [
      {
				src: '../../static/img/fazhanoneimg.png',
        title: '策划调研',
				time: '2018.10.01',
				icon: '../../static/img/icons/fazhanone.png',
				txt: '市场调研、产品定位、功能设定、产品开发。'
			},
			{
				src: '../../static/img/fazhantwoimg.png',
				title: '技术研发',
				time: '2020.05.01',
				icon: '../../static/img/icons/fazhantwo.png',
				txt: '开发并发布Android和Ios 2个版本的产品。'
			},
			{
				src: '../../static/img/fazhanthreeimg.png',
				title: '产品发布',
				time: '2020.06.01',
				icon: '../../static/img/icons/fazhanthree.png',
				txt: '导入TMS订单、自有货车在平台上的接单，定期抽样100个订单的参与反馈，进行产品优化。'
			},
			{
				src: '../../static/img/fazhanfourimg.png',
				title: '区域试运行',
				time: '2021.10.01',
				icon: '../../static/img/icons/fazhanfour.png',
				txt: '分析已有车辆、货主运营数据，优化平台运营体系、市场推广路径；立足上海区域2000台，日服务760订单的前提下，开始进行重点区域试点搭建分公司和营运中心。'
			},
			{
				src: '../../static/img/fazhanfiveimg.png',
				title: '全市场规模化',
				time: '2022.10.01',
				icon: '../../static/img/icons/fazhanfive.png',
				txt: '全面进入全国推广阶段，目标服务超过10000台车辆，服务全国区域。'
			}
		],
		isshow: '',
    setHeight: '0px'
	}
},
watch: {
  'key': function (navl, oavl) {
    if (navl === '3') {
      setTimeout(() => {
        let dom = this.$refs.getheight
        this.setHeight = dom.offsetHeight + 'px'
    }, 300)
    }
  }
},
// 生命周期 - 创建完成（访问当前this实例）
created () {},
// 生命周期 - 挂载完成（访问DOM元素）
mounted () {
  this.$nextTick(() => {
        window.onresize = () => {
          return (() => {
            if (this.key === '3') {
              setTimeout(() => {
                let dom = this.$refs.getheight
                this.setHeight = dom.offsetHeight + 'px'
              }, 300)
            }
          })()
        }
      })
},
methods: {
	handleSelect (key, keyPath) {
			console.log(key, keyPath)
			this.key = key
	},
	enter (title) {
			this.isshow = title
	},
	leave () {
			this.isshow = ''
	}
}
}
</script>
<style lang="less" scoped>
.title {
  font-size: 1vw;
}
.content {
  font-size: 0.5vw;
}
.itemClass {
  background: rgba(52, 54, 64, 0.7);
  color: white;
  // font-size: 0.5vw;
  text-align: left;
  padding:16px;
}
.content1 {
    font-size: 0.1vw;
  }
  .title1 {
    font-size: 0.5vw;
  }
.bg {
  margin:50px 0px;
  background: url('../../static/img/bg.png') no-repeat;
  background-size:100% 100%;
  padding: 0 15%;
  display: flex;
  flex-direction: column;
}
/* @import url(); 引入css类 */
#companyProfile{
    margin-top: 5vw;
}
.el-menu-demo{
    display: inline-block;
    border:none;
}
.el-menu-demo li{
    height: 40px;
    line-height: 40px;
    font-size: 1vw;
    margin-right: 5vw;
    letter-spacing: 5px;
    border-bottom:none !important;
    color: #767676;
    border-radius: 20px !important;
}
.el-menu-demo li.is-active{
    background-color: #419EFF !important;
    border:none !important;
    border-radius: 20px !important;
    color: #fff !important;
}
.keyOne{
    width: 80%;
    margin: 50px auto 50px;
    overflow: hidden;
    background-color: #fff;
}
.keyOneL{
    float: left;
    width:50%;
    text-align: left;
}
.keyOneL h2{
    display: inline-block;
    vertical-align: middle;
    color: #419EFF;
    font-size: 1.4vw;
    font-weight: 600;
}
.keyOneL .line{
    display: inline-block;
    width: 60px;
    height: 1px;
    background-color: #419EFF;
    vertical-align: middle;
    margin: 0 10px;
}
.keyOneL span{
    display: inline-block;
    vertical-align: middle;
    color: #419EFF;
    font-size: 1.4vw;
}
.keyOneR{
    float: right;
    width:42%;
    height: auto;
}
.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.image {
    width: 100%;
    display: block;
}
.imgtxt {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    color: #fff;
    background-color: #419EFF;
    padding: 10px;
    box-sizing: border-box;
		opacity: 0.9;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}
// .keyThree{
//     /* width: 80%; */
//     margin: 50px auto;
// }
// .keyThree .keyThreeIn{
//   flex: 1;
//   background-color: #fff;
//   box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
//   /* margin-right:20px; */
// }
// .keyThree .keyThreeIn img{
//   width: 30%;
// }
// .keyThree .keyThreeIn .bottom{
//   display: inline-block;
//   width: 69%;
//   text-align: left;
//   vertical-align: top;
//   padding-left:10px;
//   padding-right: 10px;
//   box-sizing: border-box;
// }
// .keyThree .keyThreeIn h2{
//   font-size: 24px;
//   line-height: 60px;
// }
// .keyThree .keyThreeIn p{
//   letter-spacing: 2px;
//   line-height: 20px;
// }
.fullscreen-enter{
  animation:fullscreen-dialog-fade-in .3s ease;
}
.fullscreen-leave{
  animation:fullscreen-dialog-fade-out .3s ease forwards;
}
.fullscreen-enter-active{
  animation:fullscreen-dialog-fade-in .3s ease
}
.fullscreen-leave-active{
  animation:fullscreen-dialog-fade-out .3s ease forwards
}

@keyframes fullscreen-dialog-fade-in {
  0% {
    transform: translate3d(0, 100%, 0);
    opacity: 0.9;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 0.9;
  }
}

@keyframes fullscreen-dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 0.9;
  }
  100% {
    transform: translate3d(0, 100%, 0);
    opacity: 0.9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyProfile.vue